import { profile } from "../stores/storages/ProfileStorage"
import api from "./api";
import config from "./config"
import formatter from './formatter'

const MetaData = {
  getMetaData: async (url) => {
    const { token, username: msisdn } = profile;
    const timestamp = new Date().getTime();
    const security = formatter.encrypt(`${msisdn}${url}${token}${timestamp}`, true);
    let data = {
      params: {
        msisdn,
        url,
        timestamp,
        security,
      }
    };
    let options = {
      decrypt: false,
    }
    return await api.request({
      method: config.endpoints.media.getMetadata.method,
      path: config.endpoints.media.getMetadata.path,
      host: config.host,
      data,
      options,
    }, true)
  }
}

export default MetaData;